import * as React from "react";
import { createPortal } from "react-dom";

type PortalProps = {
  children: React.ReactNode;
  portalName: string;
  type?: string;
};

export function Portal({ children, portalName, type }: PortalProps) {
  const portalChild = React.useMemo(() => {
    if (typeof document === "undefined") {
      return null;
    }

    return document.createElement("div");
  }, []);

  React.useEffect(() => {
    const portalRoot = document.getElementById(portalName);

    if (!portalChild || !portalRoot) {
      return;
    }

    if (type) {
      portalChild.setAttribute("data-type", type);
    }

    portalRoot.append(portalChild);

    return () => {
      portalRoot.removeChild(portalChild);
    };
  }, [portalChild, portalName, type]);

  if (!portalChild) {
    return null;
  }

  return createPortal(children, portalChild);
}
